import React from 'react';
import Carousel from '../../Componentes/Carousel/Carousel';
import './Home.css';



function Home(){
  return( <Carousel className="Demo"></Carousel>
    
)
 
  
};

export default Home;